import type { AxiosError } from 'axios';

export function isAxiosError(val: unknown): val is AxiosError {
  if (val != null && typeof val === 'object') {
    const pae = val as Partial<AxiosError>;
    return Boolean(pae.isAxiosError || pae.response);
  }
  return false;
}

export function httpErrorStatus(val: unknown): number | undefined {
  if (!val) {
    return undefined;
  }
  /*
    Axios has status in val.response.status, while fetch() has it in
    val.status.
    For aws sdk errors, it is in val.$metadata.httpStatusCode.
  */
  const v = val as any;
  const status = v.response?.status ?? v.status ?? v.$metadata?.httpStatusCode;
  if (typeof status === 'number') {
    return status;
  }

  return undefined;
}
